import styled, { css } from 'styled-components';
import { Button } from '../button/button.component.js';

const focus = (props) => css `
    transition: none;
    box-shadow: 0 0 0 2px ${props.theme.colors.content[props.color]};
    outline: transparent solid 2px;
    border: 1px solid ${props.theme.colors.content[props.color]};
  `;
const StyledButton = styled(Button).attrs(props => ({
    backgroundless: true,
    color: props.color,
})) `
  background: none;
  border: ${props => props.color === 'primaryInverse'
    ? `1px solid ${props.theme.colors.content.primaryInverse}`
    : '1px solid rgba(0, 0, 0, 0.2)}'};
  color: ${props => props.theme.colors.content[props.color]};
  min-height: 32px;
  line-height: 12px;
  padding: 0;
  min-width: 32px;

  &:focus {
    ${focus}
  }
`;

export { StyledButton };
